var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"grid-list-xl px-0 mt-120"},[_c('v-row',{attrs:{"justify":"center","align":"center mt-70"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"11"}},[_c('span',[_vm._v("PC VIEW SUPPORTED ONLY")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }